<template>
  <div class="mt-1 mb-0">
    <v-flex style="background-color:#f6f6f6;" class="px-3 pt-1 pb-2 py-2 elevation-0 xs12">
      <h3 class="subtitle xs12 flex">
        <v-icon color="#444" class="mt-0 mr-2">{{icon}}</v-icon> 
        <span class="mt-0 pt-0 pb-3">{{title}}</span>
        <!-- <v-spacer></v-spacer> -->
        <!-- <span><v-btn class="right mt-0 pt-0" icon @click.native="$emit('showUpload')" ><v-icon>add</v-icon></v-btn></span> -->
      </h3>
    </v-flex>
  </div>

</template>

<script>
  
  export default {
    props: ['icon','title'],
    data: () => ({
      // showUpload2: this.showUpload
    })
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/artworks/HeaderElements.vue